var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    attrs: {
      "id": "assets_data_table"
    }
  }, [_c('div', {
    staticClass: "controls"
  }, [_c('div', {
    staticClass: "filter_container"
  }, [_c('div', {
    staticClass: "filter_input_container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.search,
      expression: "search"
    }],
    staticClass: "filter",
    attrs: {
      "type": "text",
      "placeholder": "Filter by Asset Name"
    },
    domProps: {
      "value": _vm.search
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value;
      }
    }
  })])])]), _c('v-data-table', {
    attrs: {
      "items": _vm.assets,
      "headers": _vm.headers,
      "items-per-page": 15,
      "search": _vm.search,
      "multi-sort": "",
      "mobile-breakpoint": 0
    },
    scopedSlots: _vm._u([{
      key: "item.symbol",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [item.symbol && _vm.$vuetify.breakpoint.smAndUp ? _c('p', {
          staticClass: "symbol"
        }, [_vm._v(" " + _vm._s(item.symbol) + " ")]) : _vm._e(), !item.symbol && _vm.$vuetify.breakpoint.smAndUp ? _c('p', {
          staticClass: "no_symbol"
        }) : _vm._e()];
      }
    }, {
      key: "item.name",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_c('router-link', {
          attrs: {
            "to": "/asset/".concat(item.id)
          }
        }, [_c('div', {
          staticClass: "logo_name_id"
        }, [_c('div', {
          staticClass: "logo_container"
        }, [_vm.type(item) === 'Fixed Cap' || _vm.type(item) === 'Variable Cap' ? _c('AssetLogoRenderer', {
          attrs: {
            "asset": item
          }
        }) : _c('NFTLogoRenderer', {
          attrs: {
            "asset": item
          }
        })], 1), _c('div', {
          staticClass: "name_id"
        }, [_c('span', {
          staticClass: "name"
        }, [_vm._v(_vm._s(_vm._f("nameOrID")(item)) + " ")]), _c('span', {
          staticClass: "collision"
        }, [_vm._v(_vm._s(_vm.collisionHash(item)))])])])])];
      }
    }, {
      key: "item.nft",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return [_vm.$vuetify.breakpoint.smAndUp ? _c('p', {
          staticClass: "nft"
        }, [_vm._v(" " + _vm._s(_vm.type(item)) + " ")]) : _vm._e()];
      }
    }, {
      key: "item.currentSupply",
      fn: function fn(_ref4) {
        var item = _ref4.item;
        return [_vm.$vuetify.breakpoint.smAndUp ? _c('p', {
          staticClass: "supply"
        }, [_vm._v(" " + _vm._s(item.currentSupply.toLocaleString(item.denomination)) + " "), _c('span', [_vm._v(_vm._s(item.symbol))])]) : _vm._e()];
      }
    }, {
      key: "item.chainID",
      fn: function fn(_ref5) {
        var item = _ref5.item;
        return [_vm.$vuetify.breakpoint.smAndUp ? _c('p', {
          staticClass: "chain"
        }, [_vm._v(" " + _vm._s(_vm._f("blockchain")(item.chainID)) + " ")]) : _vm._e()];
      }
    }])
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }